import { render, staticRenderFns } from "./SaleOrderEmail.vue?vue&type=template&id=244970f0&"
import script from "./SaleOrderEmail.vue?vue&type=script&lang=js&"
export * from "./SaleOrderEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports